const InvoiceType = {
    Purchase: "Purchase",
    Sales: "Sales"
};

export default InvoiceType;
